module.exports = __webpack_public_path__ + "static/media/notfound.ddded74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/partials/property-card/images/notfound.png
// module id = 606
// module chunks = 0